import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class DeleteSeenTask extends AbstractRequestTask {

  constructor(object_id = '',  version='v1') {
    super();
    this._object_id = object_id;
    this.version = version;

  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'seendel';      
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getParams() {
    const params = super.getParams();
    const object_id = this._object_id;

    const device_id = Device.getDevice().getConfig().device_id;
    const object_type = 1;

    delete params.api_version;
    delete params.HKS;


    return Object.assign({}, params, { object_id, device_id, object_type });
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default DeleteSeenTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/DeleteSeenTask.js